import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { OnboardingBottomSheetComponent } from '../onboarding-bottom-sheet/onboarding-bottom-sheet.component';

@Component({
  selector: 'app-onboarding-header',
  templateUrl: './onboarding-header.component.html',
  styleUrls: ['./onboarding-header.component.scss'],
})
export class OnboardingHeaderComponent implements OnInit {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() information?: string;
  @Input() bottomSheetText?: string;
  @Input() backButton?: boolean;
  @Output() buttonClick = new EventEmitter<void>();

  constructor(private _bottomSheet: MatBottomSheet) {}

  ngOnInit(): void {}

  openBottomSheet(): void {
    this._bottomSheet.open(OnboardingBottomSheetComponent, {
      data: { content: this.bottomSheetText },
      backdropClass: 'modal-background',
      panelClass: 'bottom-sheet-container',
    });
  }

  handleClick(): void {
    this.buttonClick.emit();
  }
}
